import { Unstable_Grid2 as Grid } from '@mui/material';

import { Switches, TextField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { LimitFormContentLayout } from '../components/limit-form-content-layout';
import { LimitFormNamePaths } from '../types';

type ProgressPerTransactionLimitProps = {
  open: boolean;
};

export const ProgressPerTransactionLimit = ({ open }: ProgressPerTransactionLimitProps) => {
  return (
    <LimitFormContentLayout
      title='Progress Limit Per Transaction'
      description='Limit the progress a member can make on a offer during a transaction'
      action={
        <Switches
          name={'awardCount.progressPerTransaction.isEnabled' satisfies LimitFormNamePaths}
          data={{}}
        />
      }
      open={open}
    >
      <Grid container spacing={3}>
        <Grid xs={3}>
          <TextField
            name={'awardCount.progressPerTransaction.limit' satisfies LimitFormNamePaths}
            label='Limit'
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>
      </Grid>
    </LimitFormContentLayout>
  );
};
